import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/auth";
import { Link } from "react-router-dom";

import NotFound from "../404";

const Masterclass = () => {
  const dispatch = useDispatch();
  const access = useSelector((state) => state.auth.access);

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: false }));
  });
  const MasterPage = () => {
    return (
      <section className="mid_wrap">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-4 pb-2">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Master Class Training
              </li>
            </ol>
          </nav>
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="bx_a">
                <div className="emptyDiv">
                  <img
                      src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                      alt="img"
                      className="mt-4"
                    />
                    <br />
                    <h1 className="mb-4 pb-3 small_title d-flex">
                      
                    </h1>
                    <a href="https://register.gotowebinar.com/register/6891259924450217309" className="btn btn-primary" target="_blank" rel="noreferrer">Join VidAmaze Masterclass Session 1</a>
                    <br />
                    <a href="https://register.gotowebinar.com/register/6891259924450217309" className="btn btn-primary" target="_blank" rel="noreferrer">Join VidAmaze Masterclass Session 2</a>
                </div>
              </div>
            </div>
          </div>
          <div className="row my-5">
            <div className="col-md-12 my-5"></div>
          </div>
        </div>
      </section>
    );
  };
  return (
    <>
      {access.includes("8") ||
      access.includes("3") ||
      access.includes("81") ||
      access.includes("1a") ||
      access.includes("1b") ||
      access.includes("4A") ||
      access.includes("8A") ||
      access.includes("8B") ||
      access.includes("9A") ? (
        <MasterPage />
      ) : (
        <NotFound />
      )}
    </>
  );
};

export default Masterclass;
